import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  FormHelperText,
  IconButton,
  InputAdornment,
  Link,
  CircularProgress,
} from "@mui/material";
import {
  FacebookRounded,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
// import logo from "../../assets/esignlogo.png";
import useSnack from "../../hooks/useSnack";
import { useTheme } from "../../style/theme";
import useSignIn from "react-auth-kit/hooks/useSignIn";
import axiosInstance from "../../utilities/axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import useErrorHandler from "../../hooks/useErrorHandler";
import { FacebookTwoTone } from "@mui/icons-material";
import { FcGoogle } from "react-icons/fc";
import { FaFacebookMessenger } from "react-icons/fa";
import { signInWithPopup, signOut } from "firebase/auth";
import {
  auth,
  facebookProvider,
  googleProvider,
} from "../../utilities/firebase.config";
import { getReferredBy } from "../../utilities/ReferralTracker";

const API_BASE_URL = "https://api.accounts.clikkle.com/api";

const LoginForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [userName, setUserName] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [step, setStep] = useState(1);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const { SnackBar, showMessage } = useSnack();
  const signIn = useSignIn();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirecttoParam = searchParams.get("redirectto");
  const errorHandler = useErrorHandler();

  const handleEmailChange = (e) => {
    const value = e.target.value;
    if (value.length <= 50) setEmail(value);
  };

  const handlePasswordChange = (e) => setPassword(e.target.value);

  const handleEmail = async () => {
    setLoading(true);
    try {
      setErrors({});
      const formData = new FormData();
      formData.append("email", email + "@clikkmail.com");
      localStorage.setItem("email", email + "@clikkmail.com");

      const response = await fetch(
        `https://api.accounts.clikkle.com/api/auth/login_email`,
        {
          method: "POST",
          body: formData,
        }
      );

      const responseData = await response.json();
      if (response.ok && responseData.success) {
        // console.log(responseData);
        setStep(2);
        showMessage({ success: "Email verified. Proceed to login." });
      } else {
        const message = responseData.message || "Something went wrong.";
        setErrors({ email: message });
        showMessage({ error: message });
      }
    } catch (error) {
      // console.error("Email step error:", error);
      setErrors({ email: "An error occurred. Please try again." });
      showMessage({ error: "Network or server error. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async (e) => {
    setLoading(true);
    try {
      setErrors({});
      const formData = new FormData();
      formData.append("email", email + "@clikkmail.com");
      formData.append("password", password);
      formData.append("login_app", "Clikkle Projects");

      const response = await fetch(
        `https://api.accounts.clikkle.com/api/auth/login`,
        {
          method: "POST",
          body: formData,
        }
      );

      const responseData = await response.json();

      if (response.ok && responseData.success) {
        // console.log(responseData.user.username, "responseData");

        e.preventDefault();
        // setLoading(true);
        try {
          // setUserName(responseData.user.username);
          const response = await axiosInstance.post("/api/v2/auth/login", {
            userName: responseData.user.username,
            // password: password,
            recoveryEmail: responseData.user.recoveryEmail,
            firstName: responseData.user.firstName,
            lastName: responseData.user.lastName,
          });
          const { userDetails, token } = response.data;

          // console.log(userDetails, "userdet");
          localStorage.setItem("user", JSON.stringify(responseData.user));
          signIn({
            auth: {
              token,
            },
            userState: userDetails,
          });
          responseData.sourceUrl = redirecttoParam
            ? `${window.location.origin}${redirecttoParam}`
            : `${window.location.origin}/listOrganization`;
          const json = JSON.stringify(responseData);
          const encoded = btoa(json);
          const target = new URL("https://accounts.clikkle.com/other-apps/");
          target.searchParams.set("user", encoded);
          window.location.href = target.toString();
          // navigate("/listOrganization", { unstable_viewTransition: true });
        } catch (err) {
          // console.log("Login error:", err);
          errorHandler(err);
        } finally {
          setLoading(false);
        }

        // localStorage.setItem(
        //   "refreshToken",
        //   JSON.stringify(responseData.refreshToken)
        // );
        // setCookie("accessToken", responseData.refreshToken);
        // setCookie("userId", responseData.user._id);
        // setCookie("fullName", responseData.user.username);
        // setCookie("role", responseData.user.role);
        // showMessage({ success: "Login successful!" });
        // window.location.href = "/";
      } else {
        const message = responseData.message || "Invalid login credentials.";
        setErrors({ password: message });
        showMessage({ error: message });
      }
    } catch (error) {
      // console.error("Login error:", error);
      setErrors({ password: "An error occurred. Please try again." });
      showMessage({ error: "Network or server error. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = (event) => event.preventDefault();
  const { mode } = useTheme();

  const isDarkMode = mode === "dark";

  const [loadding, setLoadding] = useState(false);

  const [error, setError] = useState("");
  const [user, setUser] = useState(null);
  const [tokens, setTokens] = useState(null);
  let popupInProgress = false;

  const generateRandomPassword = (length = 12) => {
    const charset =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+-=";
    try {
      const randomValues = new Uint32Array(length);
      window.crypto.getRandomValues(randomValues);
      return Array.from(randomValues)
        .map((v) => charset[v % charset.length])
        .join("");
    } catch (e) {
      let res = "";
      for (let i = 0; i < length; i++) {
        res += charset[Math.floor(Math.random() * charset.length)];
      }
      return res;
    }
  };

  const withSuppressedFirebasePopupAssertion = async (fn) => {
    const handler = (ev) => {
      try {
        const r = ev.reason;
        const msg = r && (r.message || r.code || String(r));
        if (
          (typeof msg === "string" &&
            msg.includes("Pending promise was never set")) ||
          (r && r.code === "auth/popup-closed-by-user")
        ) {
          ev.preventDefault();
          console.warn(
            "Suppressed firebase unhandled rejection during popup:",
            r
          );
        }
      } catch (suppressErr) {}
    };

    window.addEventListener("unhandledrejection", handler);
    try {
      return await fn();
    } finally {
      window.removeEventListener("unhandledrejection", handler);
    }
  };

  const handleSocialLogin = async (provider) => {
    if (popupInProgress) {
      console.warn("Popup already in progress, ignoring duplicate click.");
      return;
    }
    popupInProgress = true;
    setLoadding(true);
    setError("");

    try {
      if (!["google", "facebook"].includes(provider))
        throw new Error("Invalid provider");
      const authProvider =
        provider === "google" ? googleProvider : facebookProvider;

      let socialResult;
      try {
        socialResult = await withSuppressedFirebasePopupAssertion(() =>
          signInWithPopup(auth, authProvider)
        );
      } catch (firebaseErr) {
        console.error(
          "Firebase popup error:",
          firebaseErr?.code,
          firebaseErr?.message
        );
        if (
          firebaseErr?.code === "auth/popup-closed-by-user" ||
          firebaseErr?.code === "auth/cancelled-popup-request" ||
          firebaseErr?.code === "auth/popup-blocked"
        ) {
          setError(
            firebaseErr.message || "Social login popup closed/cancelled."
          );
          showMessage({
            error: firebaseErr.message || "Social login cancelled.",
          });
          return;
        }
        throw firebaseErr;
      }

      const idToken = await socialResult.user.getIdToken();

      const resp = await fetch(`${API_BASE_URL}/auth/socialLogin`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          idToken,
          provider,
          login_app: "Clikkle Projects",
                    referred_by: getReferredBy(),

        }),
      });
      const data = await resp.json();
      if (!resp.ok) throw new Error(data.message || "Social login failed");

      const randomPassword = generateRandomPassword(14);
      const displayName = socialResult.user.displayName || "";
      const firstNameFromDisplay = displayName ? displayName.split(" ")[0] : "";
      const lastNameFromDisplay = displayName
        ? displayName.split(" ").slice(1).join(" ")
        : "";

      const signupData = {
        userName:
          socialResult.user.username ||
          (socialResult.user.email
            ? socialResult.user.email.split("@")[0]
            : firstNameFromDisplay.toLowerCase()) ||
          "",
        firstName: socialResult.user.firstName || firstNameFromDisplay || "",
        lastName: socialResult.user.lastName || lastNameFromDisplay || "",
        email: socialResult.user.recoveryEmail || socialResult.user.email || "",
        password: randomPassword,
      };

      if (data.success) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("refreshToken", data.refreshToken);
        localStorage.setItem("sessionToken", data.sessionToken);

        setTokens({
          token: data.token,
          refreshToken: data.refreshToken,
          sessionToken: data.sessionToken,
        });

        setUser(data.user);
        showMessage({ success: "Login successful!" });
      } else {
        console.warn("socialLogin returned success=false:", data);
      }

      try {
        const regRes = await axiosInstance.post(
          "/api/v2/auth/register",
          signupData
        );
        console.log("Register succeeded:", regRes?.data || regRes);
      } catch (regErr) {
        console.warn(
          "Register failed but continuing to redirect:",
          regErr?.response?.data || regErr.message || regErr
        );
      }

      data.sourceUrl = redirecttoParam
        ? `${window.location.origin}${redirecttoParam}`
        : window.location.origin;
      const json = JSON.stringify(data);
      const encoded = btoa(json);
      const target = new URL("https://accounts.clikkle.com/other-apps/");
      target.searchParams.set("user", encoded);
      window.location.href = target.toString();
    } catch (error) {
      console.error("Social login error:", error);
      setError(error.message || "An error occurred during login");
      showMessage({ error: error.message || "An error occurred during login" });

      try {
        if (!(error?.code === "auth/popup-closed-by-user")) {
          await signOut(auth);
        }
      } catch (signOutError) {
        console.error("Sign out error:", signOutError);
      }
    } finally {
      popupInProgress = false;
      setLoadding(false);
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      // bgcolor="background.default"       // ← use theme background
    >
      <Box
        // bgcolor="background.paper"      // ← paper surface
        display="flex"
        flexDirection="column"
        alignItems="center"
        width="100%"
        maxWidth={400}
        px={3}
        py={4}
      >
        <Box mb={1}>
          <Link href="https://worksuite.clikkle.com/projects">
            <img
              alt="Clikkle logo"
              style={{ height: "40px" }}
              src={
                isDarkMode
                  ? "https://cdn.clikkle.com/images/projects/logo/2025/Clikkle%20Projects%20Blue%20(%20White%20Text).png"
                  : "https://cdn.clikkle.com/images/projects/logo/2025/Clikkle%20Project%20Blue%20(%20Black%20Text).png"
              }
            />
          </Link>
        </Box>
        <Typography
          variant="body1"
          // color="text.secondary"
          textAlign="center"
          sx={{ mb: 2 }}
        >
          Sign in to continue to your dashboard and access all features.
        </Typography>

        <div className="flex flex-col gap-4 w-full mt-4  mx-auto">
          <button
            type="button"
            onClick={() => handleSocialLogin("google")}
            disabled={loadding}
            className={`w-full flex items-center justify-center py-2 md:py-3 px-3 md:px-4 border rounded-full shadow-sm text-sm md:text-sm font-medium transition duration-150 ease-in-out
    border-gray-300 dark:border-gray-600 
    text-gray-700 dark:text-gray-200 
    hover:bg-gray-50 dark:hover:bg-gray-700
    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
    disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-transparent`}
          >
            <FcGoogle className="h-4 w-4 md:h-5 md:w-5 mr-4" />
            Continue with Google
          </button>

          <button
            type="button"
            onClick={() => handleSocialLogin("facebook")}
            disabled={loadding}
            className={`w-full flex items-center justify-center py-2 md:py-3 px-3 md:px-4 border rounded-full shadow-sm text-sm md:text-sm font-medium transition duration-150 ease-in-out
    border-gray-300 dark:border-gray-600 
    text-gray-700 dark:text-gray-200 
    hover:bg-gray-50 dark:hover:bg-gray-700
    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
    disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-transparent`}
          >
            <FacebookTwoTone className="h-4 w-4 md:h-5 md:w-5 mr-4 text-[#3b5998] dark:text-[#1877f2]" />
            Continue with Facebook
          </button>
        </div>
        <div className="my-4 flex items-center w-full  mx-auto">
          <div className="flex-grow border-t border-gray-300 dark:border-gray-600"></div>
          <span className="flex-shrink mx-3 md:mx-4 text-xs md:text-sm text-gray-500 dark:text-gray-400">
            OR
          </span>
          <div className="flex-grow border-t border-gray-300 dark:border-gray-600"></div>
        </div>
        {step === 1 ? (
          <>
            <Typography
              variant="h6"
              fontWeight="bold"
              gutterBottom
              textAlign="center"
            >
              Use your Clikkle account
            </Typography>
          </>
        ) : (
          <Typography
            variant="h6"
            fontWeight="medium"
            sx={{
              px: 2,
              pb: 1.5,
              borderRadius: "6px",
              width: "100%",
              textAlign: "center",
            }}
          >
            {email}@clikkmail.com
          </Typography>
        )}

        <Typography
          variant="body1"
          color="text.secondary"
          gutterBottom
          sx={{ mb: 2 }}
        >
          {step === 1
            ? "Step 1 of 2: Enter your email"
            : "Step 2 of 2: Enter your password"}
        </Typography>

        {step === 1 && (
          <TextField
            size="small"
            fullWidth
            label="Email"
            value={email}
            onChange={handleEmailChange}
            error={Boolean(errors.email)}
            helperText={errors.email}
            sx={{ mb: 3 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Typography variant="body2">@clikkmail.com</Typography>
                </InputAdornment>
              ),
            }}
          />
        )}

        {step === 2 && (
          <>
            <TextField
              fullWidth
              size="small"
              type={showPassword ? "text" : "password"}
              label="Password"
              value={password}
              onChange={handlePasswordChange}
              error={Boolean(errors.password)}
              helperText={errors.password}
              sx={{ mb: 2 }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <FormHelperText sx={{ mb: 2, fontSize: "0.9rem" }}>
              Password must be at least 6 characters long and should not include
              &lt;, &gt;, or spaces.
            </FormHelperText>
            <Box width="100%" textAlign="right" mb={2}>
              <Link
                href="https://accounts.clikkle.com/account-recovery-forgot-password"
                underline="hover"
                variant="body2"
                target="_blank"
                sx={{ fontWeight: "bold" }}
              >
                Forgot password?
              </Link>
            </Box>
          </>
        )}

        <Button
          variant="contained" // ← this uses theme.palette.primary
          color="primary"
          fullWidth
          sx={{ mt: 1, py: 1.2, bgcolor: "#006AFF" }}
          onClick={step === 1 ? handleEmail : handleLogin}
          disabled={loading}
        >
          {loading ? (
            <CircularProgress size={24} sx={{ color: "#fff" }} />
          ) : step === 1 ? (
            "Next"
          ) : (
            "Login"
          )}
        </Button>

        <Typography variant="body2" align="center" sx={{ mt: 3 }}>
          Don’t have an account?{" "}
          <Link component={RouterLink} to="/signup" underline="hover">
            Sign up
          </Link>
        </Typography>

        {SnackBar}
      </Box>
    </Box>
  );
};

export default LoginForm;
